module.exports = __webpack_public_path__ + "img/bonus9.9ec13033.png";